class Post {
	title
	description
	alias
	featured
	imageLink
	link
	created
	published
	category
	template
	element

	render (postIndex) {
		if (this.element) return this.element
		this.element = this.template.getElement(this, postIndex)
		return this.element
	}
}

export { Post }



// WEBPACK FOOTER //
// ./templates/rekinysukcesu/js/extensions/mod_async_posts_loader/entities/Post.js